import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { downloadFile } from '../../../../../shared/functions/Functions';
import { IParams } from '../../../../../model/shared/IParams';
import { IBundle } from '../../../../../model/options/IBundle';
import { IBookingStats } from '../../../../../model/campaign/Campaign';
import { CampaignDashboardService } from '../service';
import { ErrorToast, WarningToast } from '../../../../../utils/toasters';
import { OptionService } from '../../options/service';
import { InternalRoutes } from '../../../../../enum/InternalRoutes';
import { IconBundle } from '../../../../../shared/Icons';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import FilePlaceholder from '../../../../../shared/components/placeholder/FilePlaceholder';
import { Fancybox } from '../../../../../shared/components/Fancybox';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { CampaignChildDashCard } from './CampaignChildDashCard';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { MUTED_TEXT_COLOR } from '../../../../../utils/constants';
import { DashStatsCardSkeleton } from './CampaignDashboardSkeletons';

export function CampaignBundleCard() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams<keyof IParams>();
    const [bundle, setBundle] = useState<IBundle | undefined>(undefined);
    const [booking, setBooking] = useState<IBookingStats>();
    const { isChildCampaign } = useSelector((states: IAllStates) => states.selectedCampaign);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        CampaignDashboardService.getBookingData(id)
            .then(data => {
                setBooking(data);
            })
            .catch(error => ErrorToast(error))
            .finally(() => setIsLoading(false));
    }, [id]);

    useEffect(() => {
        if (!!id) {
            OptionService.getBundle(id)
                .then(response => {
                    if (response.id) {
                        setBundle(response);
                    }
                })
                .catch(err => ErrorToast(err));
        }
    }, [id]);

    const linkToBundle = () => {
        navigate(`${InternalRoutes.BRAND_CAMPAIGN_OPTIONS}/${id}`);
    };

    const handleDownloadFiles = () => {
        if (!!bundle?.files?.length) {
            for (const file of bundle?.files) {
                downloadFile(file.path, file?.originalName);
            }
        } else {
            WarningToast('No uploaded files');
        }
    };
    if (isLoading) {
        return <DashStatsCardSkeleton stats={3} />;
    }
    return (
        <CardLayout classCard="mb-3">
            <h6 className="textHover mb-3 cursor-pointer" onClick={linkToBundle}>
                <IconBundle width="20" height="20" color={MUTED_TEXT_COLOR} classes={' mr-2'} />
                {t('brand.campaign.dashboard.booking.influencer_bundle')}
            </h6>
            {isChildCampaign && <CampaignChildDashCard stats={booking} isBundleCard={true} />}
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: 20 }}>
                <div className="mr-2">
                    <h3 className="text-primary">{priceSplitter(booking?.totalMatchedInfluencers ?? 0)}</h3>
                    <div>{t('brand.campaign.dashboard.booking.total_matched_influencers')}</div>
                </div>
                <div className="mx-md-4">
                    <h3 className="text-primary">{booking?.influencersBooked}</h3>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t(
                                `brand.campaign.dashboard.booking.${
                                    isChildCampaign ? 'additional_booked_infl' : 'influencers_booked'
                                }`
                            ),
                        }}
                    ></div>
                </div>
                {bundle?.budget && (
                    <div className="mx-md-4">
                        <h3 className={`text-primary d-flex ${bundle?.budget ? 'mb-0' : ''}`}>
                            {bundle?.budget ? priceSplitter(bundle?.budget) : '-'}
                            {!!bundle?.budget && <h3 className="ml-1 euro-symbol"></h3>}
                        </h3>
                        <div>{t('brand.campaign.dashboard.booking.booked_budget')}</div>
                    </div>
                )}

                {/* {bundle?.isEnabled ? (
                    <div className="col px-0">
                        <Fancybox>
                            {bundle?.files?.map((file, i) => {
                                return (
                                    <div
                                        key={file?.id}
                                        className={`${i !== 0 ? 'd-none' : 'position-relative'}`}
                                        style={{ maxWidth: 300 }}
                                    >
                                        <FilePlaceholder
                                            file={file}
                                            classContent="card-img py-2"
                                            classIcon="font-100"
                                            files={bundle?.files}
                                            nameFancybox="campaign-bundle"
                                            handleDownload={() => downloadFile(file.path, file.originalName)}
                                        />
                                    </div>
                                );
                            })}
                        </Fancybox>
                    </div>
                ) : (
                    <div className="pl-0 d-flex justify-content-center align-items-center flex-column">
                        <img width="100" src="/icons/bundle-empty-state.svg" alt="Empty state bundle" />
                        <p className="text-muted mb-0 mt-2">{t('brand.options.noOfferBundles')}</p>
                    </div>
                )} */}
                <div></div>
            </div>
        </CardLayout>
    );
}
